import React from 'react';
import { Box, Button } from '@mui/material';
import { FONT_FAMILY } from '../../theme';

const LanguageSwitcher = ({ language, setLanguage, style = 'light', floating = false }) => {
    // Style variants for different pages
    const styles = {
        light: {
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(184,124,58,0.4)',
            activeBackground: '#b87c3a',
            activeColor: '#0b0b0b',
            inactiveColor: '#efe8df',
            hoverActive: '#d9b77a',
            hoverInactive: 'rgba(255,255,255,0.15)',
        },
        dark: {
            background: 'rgba(0,0,0,0.6)',
            border: '1px solid rgba(255,255,255,0.3)',
            activeBackground: '#ed5034',
            activeColor: '#fff',
            inactiveColor: '#bbb',
            hoverActive: '#ff6b4a',
            hoverInactive: 'rgba(255,255,255,0.2)',
        }
    };

    const currentStyle = styles[style] || styles.light;

    const containerSx = floating ? {
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'center',
        boxShadow: '0 3px 15px rgba(0,0,0,0.25)',
        borderRadius: 1.5,
    } : {
        display: 'flex',
        justifyContent: 'center',
        mt: 3,
    };

    return (
        <Box sx={containerSx}>
            <Box sx={{
                display: 'flex',
                gap: 0.3,
                alignItems: 'center',
                padding: '3px',
                borderRadius: 1.5,
                background: currentStyle.background,
                border: currentStyle.border,
                backdropFilter: floating ? 'blur(10px)' : 'none',
            }}>
                <Button
                    onClick={() => setLanguage('en')}
                    sx={{
                        minWidth: '40px',
                        padding: '4px 10px',
                        borderRadius: 1,
                        border: 'none',
                        background: language === 'en' ? currentStyle.activeBackground : 'transparent',
                        color: language === 'en' ? currentStyle.activeColor : currentStyle.inactiveColor,
                        fontSize: '0.75rem',
                        fontWeight: language === 'en' ? 700 : 500,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        textTransform: 'none',
                        fontFamily: FONT_FAMILY,
                        '&:hover': {
                            background: language === 'en' ? currentStyle.hoverActive : currentStyle.hoverInactive,
                        }
                    }}
                >
                    EN
                </Button>
                <Button
                    onClick={() => setLanguage('bg')}
                    sx={{
                        minWidth: '40px',
                        padding: '4px 10px',
                        borderRadius: 1,
                        border: 'none',
                        background: language === 'bg' ? currentStyle.activeBackground : 'transparent',
                        color: language === 'bg' ? currentStyle.activeColor : currentStyle.inactiveColor,
                        fontSize: '0.75rem',
                        fontWeight: language === 'bg' ? 700 : 500,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        textTransform: 'none',
                        fontFamily: FONT_FAMILY,
                        '&:hover': {
                            background: language === 'bg' ? currentStyle.hoverActive : currentStyle.hoverInactive,
                        }
                    }}
                >
                    BG
                </Button>
            </Box>
        </Box>
    );
};

export default LanguageSwitcher;
